/**
 * Returns the file extension (dot-prefixed).
 *
 * Returns the empty string if no extension exists.
 */
export const getFileExtension = (filename: string): string => {
  const extension = filename.split('.').pop();
  return filename === extension ? '' : `.${extension}`;
};
